import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class UsageEntry  {
    _originalTypeClassName = "zvelton_Backoffice.BO.UsageEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UsageEntry.translate = translateService;
}
this.Key = new Domain.APIKey();
this.Entries = [];
this.Id = null;
this.StartedOn = null;
this.FinishedOn = null;
this.ReqId = null;
this.Charged = false;
this.Cost = null;
this.ServiceCost = null;
this.LLMCost = null;
this.Service_ToolCalls = null;
this.Service_TotalTokens = null;
this.Service_CompletionTokens = null;
this.Service_PromptTokens = null;
this.Service_ReasoningTokens = null;
this.Service_PromptTokensCached = null;
this.PricelistCostPerRequest = null;
this.PricelistLLMCostPercentage = null;
this.LLMRounds = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartedOn:any;
FinishedOn:any;
ReqId:any;
Charged:any;
Cost:any;
ServiceCost:any;
LLMCost:any;
Service_ToolCalls:any;
Service_TotalTokens:any;
Service_CompletionTokens:any;
Service_PromptTokens:any;
Service_ReasoningTokens:any;
Service_PromptTokensCached:any;
PricelistCostPerRequest:any;
PricelistLLMCostPercentage:any;
LLMRounds:any;
Key:any;
Entries:any;
static setKey = ($this, value) => {
var oldValue = $this.Key;
$this.Key = value;
if (value != null) {
}
}
static setEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Entries == null) $this.Entries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Entries.length > 0) {
                    Domain.UsageEntry.removeEntries($this, $this.Entries[0]);
                }

                Domain.UsageEntry.addManyEntries($this, copyItems);
            }
static addManyEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.UsageEntry.addEntries($this, items[i]);
                }
            }
static addEntries = ($this, item) => {
                if ($this.Entries == null) $this.Entries = [];
                if (item == null || $this.Entries.indexOf(item) > -1) return;
                $this.Entries.push(item);
}
static addRangeEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.UsageEntry.addEntries($this, item));
            }
static removeEntries = ($this, item) => {
                if ($this == null || $this.Entries == null || $this.Entries.indexOf(item) === -1) return;
                var _index = $this.Entries.indexOf(item);
                $this.Entries.splice(_index, 1);
}
static clearEntries = ($this) => { $this.Entries = null; }

static GetCost($this: any): any{return Joove.Common.safeNumber($this?.ServiceCost) + Joove.Common.safeNumber($this?.LLMCost);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}